export const SUBMITTED = "SUBMITTED";
export const REJECTED = "REJECTED";
export const NOTSUBMITTED = "NOTSUBMITTED";
